window.options = {
    slickOptions: {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        slidesToShow_Tablet: 2,
        slidesToScroll_Tablet: 1,
        slidesToShow_Mobile: 1,
        slidesToScroll_Mobile: 1,
        arrows: true
    },
    personalisationOptions: {
        loadingSpinner: {
            width: 30,
            height: 30
        }
    },
    phoneNumberNotRequiredCountries: [],
    datepicker: {
        dayViewHeaderFormat: 'MMMM',
        allowInputToggle: false
    },
    chooseProduct: {
        showOrderProcessingPopup: false
    }
};
